import { render } from "./DetalhesPedidosCanceladosLiquidados.vue?vue&type=template&id=1b65b770&scoped=true"
import script from "./DetalhesPedidosCanceladosLiquidados.vue?vue&type=script&lang=js"
export * from "./DetalhesPedidosCanceladosLiquidados.vue?vue&type=script&lang=js"

import "./DetalhesPedidosCanceladosLiquidados.vue?vue&type=style&index=0&id=1b65b770&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b65b770"]])

export default __exports__